import { 
	MeshBasicMaterial,
	MeshLambertMaterial,
	MeshPhongMaterial,
	MeshStandardMaterial,
	MeshPhysicalMaterial
} from 'three';

export class MaterialHelper{

	static getClass(className){
		switch(className){
			case "MeshBasicMaterial":
				return MeshBasicMaterial;
			case "MeshLambertMaterial":
				return MeshLambertMaterial;
			case "MeshPhongMaterial":
				return MeshPhongMaterial;
			case "MeshStandardMaterial":
				return MeshStandardMaterial;
			case "MeshPhysicalMaterial":
				return MeshPhysicalMaterial;
		}
		return null;
	}
	
	static create(name){
		let clazz = MaterialHelper.getClass(name)
		if(clazz)
			return new clazz();
		return null;
	}
}